import React from 'react';
import { Box, Fade } from '@material-ui/core';
import defaultLocales from 'globals/locales/default';
import FsPaper from 'ui-elements/main-elements/FsPaper';
import FsGridContainer from 'ui-elements/grid/FsGridContainer';
import FsGridItem from 'ui-elements/grid/FsGridItem';
import IconBox from './IconBox';
import {
  Caption,
  ImageContainer,
  Title,
  WrapperBox,
} from './InviteDescriptionBox.style-elements';
import { iconBoxesProps } from './InviteDescriptionBox.utils';

const { howItWorks: howItWorksLocales } = defaultLocales.inviteCustomersPage;

const InviteDescriptionBox: React.FC = () => {
  const paperStyle = { paddingTop: 0 };
  return (
    <WrapperBox>
      <Fade in timeout={1000}>
        <FsPaper withContentMargin={false} style={paperStyle}>
          <Box mb={2}>
            <ImageContainer />
            <Title>{howItWorksLocales.title}</Title>
            <Caption>{howItWorksLocales.caption}</Caption>
          </Box>
          <FsGridContainer>
            {iconBoxesProps.map(({ label, iconType }) => (
              <FsGridItem xs={12} sm={4} key={iconType}>
                <IconBox iconType={iconType}>{label}</IconBox>
              </FsGridItem>
            ))}
          </FsGridContainer>
        </FsPaper>
      </Fade>
    </WrapperBox>
  );
};

export default InviteDescriptionBox;
